<style lang="scss">
@import "../scss/icons";
</style>

<template>
  <icon-button
    name="save"
    class="ar-icon ar-icon__xs ar-icon--no-border"
    @click.native="upload(record)"
  />
</template>

<script>
import IconButton from "./icon-button";
import UploaderPropsMixin from "@/mixins/uploader-props";

export default {
  mixins: [UploaderPropsMixin],
  props: {
    record: { type: Object },
    upload: { type: Function }
  },
  components: {
    IconButton
  }
};
</script>
